import React from "react";
import { TableRow, TableCell, IconButton, Checkbox, Chip, Box } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTranslation } from "react-i18next";

const AirlinesTableRow = ({
    airline,
    index,
    isDark,
    page,
    perPage,
    sortBy,
    sortDir,
    totalItems,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    isArchive = false,
    menuDisabled = false,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const nameAr = airline?.name?.ar || "";
    const nameEn = airline?.name?.en || "";

    const serial =
        sortDir === "asc"
            ? (page - 1) * perPage + index + 1
            : (page - 1) * perPage + (totalItems - index);

    const isOdd = index % 2 === 0;
    const isSelected = selectedIds.includes(airline?.id);

    // Status badge
    const isActive = airline?.status === "active";
    const statusLabel = isArabic
        ? (isActive ? "نشط" : "معطل")
        : (isActive ? "Active" : "Disabled");

    // Logo placeholder if null
    const logoUrl = airline?.image?.thumbnail || "https://placehold.co/50x50?text=No+Logo";

    return (
        <TableRow
            hover
            sx={{
                backgroundColor: isOdd
                    ? isDark
                        ? "rgba(55,65,81,0.45)"
                        : "rgba(249,250,251,0.9)"
                    : "transparent",
            }}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onClick={(e) => onRowCheckboxClick(e, airline?.id)}
                    inputProps={{ "aria-labelledby": `airline-${airline?.id}` }}
                />
            </TableCell>

            <TableCell>{serial}</TableCell>

            <TableCell padding="none">
                <Box
                    component="img"
                    src={logoUrl}
                    alt={nameEn}
                    sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "4px",
                        objectFit: "contain",
                        backgroundColor: "#fff",
                        border: "1px solid #e5e7eb",
                        ml: 2,
                        my: 1
                    }}
                />
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {nameAr || "-"}
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {nameEn || "-"}
            </TableCell>

            <TableCell>
                <Chip
                    label={statusLabel}
                    size="small"
                    color={isActive ? "success" : "default"}
                    sx={{
                        fontWeight: 500,
                        minWidth: 70,
                    }}
                />
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, airline);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default AirlinesTableRow;
